export const products = [
  {
    "id": 1,
    "name": "Blue Top",
    "price": 500,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Polo",
    "image": "/images/blue_top.png",
    "rating": 4.2,
    "reviews": 38,
    "inStock": true,
    "description": "A beautiful blue top perfect for casual outings and everyday wear. Made with premium cotton blend fabric for maximum comfort.",
    "color": "Blue",
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": 2,
    "name": "Men Tshirt",
    "price": 400,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "H&M",
    "image": "/images/grey_tshirt.png",
    "rating": 4.5,
    "reviews": 62,
    "inStock": true,
    "description": "Classic men's T-shirt with a relaxed fit. Ideal for everyday casual wear.",
    "color": "Grey",
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ]
  },
  {
    "id": 3,
    "name": "Sleeveless Dress",
    "price": 1000,
    "category": "Women",
    "subcategory": "Dress",
    "brand": "Madame",
    "image": "/images/pink_dress.png",
    "rating": 4.7,
    "reviews": 45,
    "inStock": true,
    "description": "Elegant sleeveless dress for formal or semi-formal occasions.",
    "color": "Pink",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 4,
    "name": "Stylish Dress",
    "price": 1500,
    "category": "Women",
    "subcategory": "Dress",
    "brand": "Biba",
    "image": "/images/blue_stylish_dress.png",
    "rating": 4.3,
    "reviews": 28,
    "inStock": true,
    "description": "Chic and stylish dress for modern women.",
    "color": "Blue",
    "size": [
      "XS",
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": 5,
    "name": "Winter Top",
    "price": 600,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Polo",
    "image": "/images/green_winter_top.png",
    "rating": 4.1,
    "reviews": 19,
    "inStock": true,
    "description": "Warm and cozy winter top for cold seasons.",
    "color": "Green",
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": 6,
    "name": "Summer White Top",
    "price": 400,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "H&M",
    "image": "/images/white_summer_top.png",
    "rating": 4.4,
    "reviews": 51,
    "inStock": true,
    "description": "Fresh and light summer top for warm days.",
    "color": "White",
    "size": [
      "XS",
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 7,
    "name": "Madame Top For Women",
    "price": 1000,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Madame",
    "image": "/images/yellow_madame_top.png",
    "rating": 4.6,
    "reviews": 33,
    "inStock": true,
    "description": "Designer top from Madame collection for women.",
    "color": "Yellow",
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": 8,
    "name": "Fancy Green Top",
    "price": 700,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Biba",
    "image": "/images/fancy_green_top.png",
    "rating": 4,
    "reviews": 22,
    "inStock": true,
    "description": "Trendy green top with fancy design for special occasions.",
    "color": "Green",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 9,
    "name": "Blue Jeans Slim Fit",
    "price": 1499,
    "category": "Men",
    "subcategory": "Jeans",
    "brand": "Mast & Harbour",
    "image": "/images/men_blue_jeans.png",
    "rating": 4.5,
    "reviews": 88,
    "inStock": true,
    "description": "Classic slim fit blue jeans for everyday wear.",
    "color": "Blue",
    "size": [
      "28",
      "30",
      "32",
      "34",
      "36"
    ]
  },
  {
    "id": 10,
    "name": "Premium Polo T-Shirts",
    "price": 1500,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Polo",
    "image": "/images/men_red_polo.png",
    "rating": 4.8,
    "reviews": 105,
    "inStock": true,
    "description": "Premium polo t-shirt with signature embroidery.",
    "color": "Red",
    "size": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ]
  },
  {
    "id": 11,
    "name": "Graphic Design Men T Shirt",
    "price": 1389,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "H&M",
    "image": "/images/men_graphic_tee.png",
    "rating": 4.2,
    "reviews": 41,
    "inStock": true,
    "description": "Bold graphic t-shirt with artistic design print.",
    "color": "Dark Blue",
    "size": [
      "S",
      "M",
      "L",
      "XL"
    ]
  },
  {
    "id": 12,
    "name": "Soft Stretch Jeans",
    "price": 799,
    "category": "Men",
    "subcategory": "Jeans",
    "brand": "Mast & Harbour",
    "image": "/images/men_navy_jeans.png",
    "rating": 4.3,
    "reviews": 55,
    "inStock": true,
    "description": "Comfortable stretch jeans with modern slim fit.",
    "color": "Navy",
    "size": [
      "28",
      "30",
      "32",
      "34"
    ]
  },
  {
    "id": 13,
    "name": "Frozen Tops For Kids",
    "price": 278,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Babyhug",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.6,
    "reviews": 72,
    "inStock": true,
    "description": "Fun Frozen-themed top for kids with colorful print.",
    "color": "Blue",
    "size": [
      "2-3Y",
      "3-4Y",
      "4-5Y",
      "5-6Y"
    ]
  },
  {
    "id": 14,
    "name": "Little Girls Mr. Panda Shirt",
    "price": 1200,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Allen Solly Junior",
    "image": "/images/kids_panda_shirt.png",
    "rating": 4.7,
    "reviews": 38,
    "inStock": true,
    "description": "Adorable panda print shirt for little girls.",
    "color": "White",
    "size": [
      "2-3Y",
      "4-5Y",
      "6-7Y"
    ]
  },
  {
    "id": 15,
    "name": "Kids Floral Dress",
    "price": 890,
    "category": "Kids",
    "subcategory": "Dress",
    "brand": "Kookie Kids",
    "image": "/images/kids_floral_dress.png",
    "rating": 4.4,
    "reviews": 29,
    "inStock": true,
    "description": "Beautiful floral dress for little girls.",
    "color": "Multicolor",
    "size": [
      "2-3Y",
      "4-5Y",
      "6-7Y",
      "8-9Y"
    ]
  },
  {
    "id": 16,
    "name": "Sleeveless Unicorn Patch Gown",
    "price": 1050,
    "category": "Kids",
    "subcategory": "Dress",
    "brand": "Babyhug",
    "image": "/images/kids_floral_dress.png",
    "rating": 4.9,
    "reviews": 63,
    "inStock": true,
    "description": "Magical unicorn patch gown for little princesses.",
    "color": "Pink",
    "size": [
      "2-3Y",
      "4-5Y",
      "6-7Y"
    ]
  },
  {
    "id": 17,
    "name": "Cotton Silk Hand Block Print Saree",
    "price": 3000,
    "category": "Women",
    "subcategory": "Saree",
    "brand": "Biba",
    "image": "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&q=80",
    "rating": 4.8,
    "reviews": 27,
    "inStock": true,
    "description": "Handcrafted block print saree in premium cotton silk.",
    "color": "Red",
    "size": [
      "Free Size"
    ]
  },
  {
    "id": 18,
    "name": "Rust Red Linen Saree",
    "price": 3500,
    "category": "Women",
    "subcategory": "Saree",
    "brand": "Madame",
    "image": "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&q=80",
    "rating": 4.6,
    "reviews": 18,
    "inStock": true,
    "description": "Elegant rust red linen saree for festive occasions.",
    "color": "Rust Red",
    "size": [
      "Free Size"
    ]
  },
  {
    "id": 100,
    "name": "Polo Women Tops Collection V1",
    "price": 955,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Polo",
    "image": "/images/white_summer_top.png",
    "rating": 4.6,
    "reviews": 27,
    "inStock": true,
    "description": "A great Tops from Polo specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 101,
    "name": "Polo Women Tops Collection V2",
    "price": 1150,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Polo",
    "image": "/images/white_summer_top.png",
    "rating": 4.7,
    "reviews": 31,
    "inStock": true,
    "description": "A great Tops from Polo specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 102,
    "name": "Polo Women Tops Collection V3",
    "price": 867,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Polo",
    "image": "/images/white_summer_top.png",
    "rating": 4.5,
    "reviews": 74,
    "inStock": true,
    "description": "A great Tops from Polo specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 103,
    "name": "Polo Women Tops Collection V4",
    "price": 977,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Polo",
    "image": "/images/white_summer_top.png",
    "rating": 4.9,
    "reviews": 55,
    "inStock": true,
    "description": "A great Tops from Polo specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 104,
    "name": "Polo Women Tops Collection V5",
    "price": 1357,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Polo",
    "image": "/images/white_summer_top.png",
    "rating": 4.1,
    "reviews": 94,
    "inStock": true,
    "description": "A great Tops from Polo specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 105,
    "name": "H&M Women Tops Collection V1",
    "price": 1186,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "H&M",
    "image": "/images/white_summer_top.png",
    "rating": 4.2,
    "reviews": 59,
    "inStock": true,
    "description": "A great Tops from H&M specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 106,
    "name": "H&M Women Tops Collection V2",
    "price": 535,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "H&M",
    "image": "/images/white_summer_top.png",
    "rating": 4.9,
    "reviews": 68,
    "inStock": true,
    "description": "A great Tops from H&M specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 107,
    "name": "H&M Women Tops Collection V3",
    "price": 1377,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "H&M",
    "image": "/images/white_summer_top.png",
    "rating": 4.5,
    "reviews": 77,
    "inStock": true,
    "description": "A great Tops from H&M specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 108,
    "name": "H&M Women Tops Collection V4",
    "price": 866,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "H&M",
    "image": "/images/white_summer_top.png",
    "rating": 5,
    "reviews": 40,
    "inStock": true,
    "description": "A great Tops from H&M specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 109,
    "name": "H&M Women Tops Collection V5",
    "price": 1198,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "H&M",
    "image": "/images/white_summer_top.png",
    "rating": 4.3,
    "reviews": 34,
    "inStock": true,
    "description": "A great Tops from H&M specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 110,
    "name": "Madame Women Tops Collection V1",
    "price": 1277,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Madame",
    "image": "/images/white_summer_top.png",
    "rating": 4.3,
    "reviews": 27,
    "inStock": true,
    "description": "A great Tops from Madame specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 111,
    "name": "Madame Women Tops Collection V2",
    "price": 1387,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Madame",
    "image": "/images/white_summer_top.png",
    "rating": 4.2,
    "reviews": 39,
    "inStock": true,
    "description": "A great Tops from Madame specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 112,
    "name": "Madame Women Tops Collection V3",
    "price": 818,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Madame",
    "image": "/images/white_summer_top.png",
    "rating": 4.9,
    "reviews": 41,
    "inStock": true,
    "description": "A great Tops from Madame specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 113,
    "name": "Madame Women Tops Collection V4",
    "price": 571,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Madame",
    "image": "/images/white_summer_top.png",
    "rating": 4.1,
    "reviews": 96,
    "inStock": true,
    "description": "A great Tops from Madame specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 114,
    "name": "Madame Women Tops Collection V5",
    "price": 1173,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Madame",
    "image": "/images/white_summer_top.png",
    "rating": 4.5,
    "reviews": 79,
    "inStock": true,
    "description": "A great Tops from Madame specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 115,
    "name": "Biba Women Tops Collection V1",
    "price": 697,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Biba",
    "image": "/images/white_summer_top.png",
    "rating": 4.3,
    "reviews": 97,
    "inStock": true,
    "description": "A great Tops from Biba specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 116,
    "name": "Biba Women Tops Collection V2",
    "price": 1388,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Biba",
    "image": "/images/white_summer_top.png",
    "rating": 4.7,
    "reviews": 100,
    "inStock": true,
    "description": "A great Tops from Biba specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 117,
    "name": "Biba Women Tops Collection V3",
    "price": 1414,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Biba",
    "image": "/images/white_summer_top.png",
    "rating": 4.4,
    "reviews": 42,
    "inStock": true,
    "description": "A great Tops from Biba specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 118,
    "name": "Biba Women Tops Collection V4",
    "price": 963,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Biba",
    "image": "/images/white_summer_top.png",
    "rating": 4.9,
    "reviews": 22,
    "inStock": true,
    "description": "A great Tops from Biba specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 119,
    "name": "Biba Women Tops Collection V5",
    "price": 652,
    "category": "Women",
    "subcategory": "Tops",
    "brand": "Biba",
    "image": "/images/white_summer_top.png",
    "rating": 4.8,
    "reviews": 42,
    "inStock": true,
    "description": "A great Tops from Biba specifically designed for Women. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 120,
    "name": "Polo Men Tshirts Collection V1",
    "price": 893,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Polo",
    "image": "/images/grey_tshirt.png",
    "rating": 4.5,
    "reviews": 61,
    "inStock": true,
    "description": "A great Tshirts from Polo specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 121,
    "name": "Polo Men Tshirts Collection V2",
    "price": 779,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Polo",
    "image": "/images/grey_tshirt.png",
    "rating": 4,
    "reviews": 57,
    "inStock": true,
    "description": "A great Tshirts from Polo specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 122,
    "name": "Polo Men Tshirts Collection V3",
    "price": 1471,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Polo",
    "image": "/images/grey_tshirt.png",
    "rating": 4.2,
    "reviews": 101,
    "inStock": true,
    "description": "A great Tshirts from Polo specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 123,
    "name": "Polo Men Tshirts Collection V4",
    "price": 1459,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Polo",
    "image": "/images/grey_tshirt.png",
    "rating": 4.5,
    "reviews": 10,
    "inStock": true,
    "description": "A great Tshirts from Polo specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 124,
    "name": "Polo Men Tshirts Collection V5",
    "price": 611,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Polo",
    "image": "/images/grey_tshirt.png",
    "rating": 4.3,
    "reviews": 49,
    "inStock": true,
    "description": "A great Tshirts from Polo specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 125,
    "name": "H&M Men Tshirts Collection V1",
    "price": 1292,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "H&M",
    "image": "/images/grey_tshirt.png",
    "rating": 4.8,
    "reviews": 102,
    "inStock": true,
    "description": "A great Tshirts from H&M specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 126,
    "name": "H&M Men Tshirts Collection V2",
    "price": 533,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "H&M",
    "image": "/images/grey_tshirt.png",
    "rating": 4.8,
    "reviews": 51,
    "inStock": true,
    "description": "A great Tshirts from H&M specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 127,
    "name": "H&M Men Tshirts Collection V3",
    "price": 908,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "H&M",
    "image": "/images/grey_tshirt.png",
    "rating": 4.3,
    "reviews": 80,
    "inStock": true,
    "description": "A great Tshirts from H&M specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 128,
    "name": "H&M Men Tshirts Collection V4",
    "price": 1434,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "H&M",
    "image": "/images/grey_tshirt.png",
    "rating": 4.8,
    "reviews": 99,
    "inStock": true,
    "description": "A great Tshirts from H&M specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 129,
    "name": "H&M Men Tshirts Collection V5",
    "price": 1169,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "H&M",
    "image": "/images/grey_tshirt.png",
    "rating": 4,
    "reviews": 104,
    "inStock": true,
    "description": "A great Tshirts from H&M specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 130,
    "name": "Mast & Harbour Men Tshirts Collection V1",
    "price": 621,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Mast & Harbour",
    "image": "/images/grey_tshirt.png",
    "rating": 4.6,
    "reviews": 54,
    "inStock": true,
    "description": "A great Tshirts from Mast & Harbour specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 131,
    "name": "Mast & Harbour Men Tshirts Collection V2",
    "price": 713,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Mast & Harbour",
    "image": "/images/grey_tshirt.png",
    "rating": 4.5,
    "reviews": 64,
    "inStock": true,
    "description": "A great Tshirts from Mast & Harbour specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 132,
    "name": "Mast & Harbour Men Tshirts Collection V3",
    "price": 620,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Mast & Harbour",
    "image": "/images/grey_tshirt.png",
    "rating": 4.5,
    "reviews": 100,
    "inStock": true,
    "description": "A great Tshirts from Mast & Harbour specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 133,
    "name": "Mast & Harbour Men Tshirts Collection V4",
    "price": 1190,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Mast & Harbour",
    "image": "/images/grey_tshirt.png",
    "rating": 4.5,
    "reviews": 44,
    "inStock": true,
    "description": "A great Tshirts from Mast & Harbour specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 134,
    "name": "Mast & Harbour Men Tshirts Collection V5",
    "price": 624,
    "category": "Men",
    "subcategory": "Tshirts",
    "brand": "Mast & Harbour",
    "image": "/images/grey_tshirt.png",
    "rating": 4.6,
    "reviews": 81,
    "inStock": true,
    "description": "A great Tshirts from Mast & Harbour specifically designed for Men. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 135,
    "name": "Babyhug Kids Tops & Shirts Collection V1",
    "price": 847,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Babyhug",
    "image": "/images/kids_frozen_top.png",
    "rating": 4,
    "reviews": 76,
    "inStock": true,
    "description": "A great Tops & Shirts from Babyhug specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 136,
    "name": "Babyhug Kids Tops & Shirts Collection V2",
    "price": 1291,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Babyhug",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.6,
    "reviews": 18,
    "inStock": true,
    "description": "A great Tops & Shirts from Babyhug specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 137,
    "name": "Babyhug Kids Tops & Shirts Collection V3",
    "price": 1022,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Babyhug",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.2,
    "reviews": 68,
    "inStock": true,
    "description": "A great Tops & Shirts from Babyhug specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 138,
    "name": "Babyhug Kids Tops & Shirts Collection V4",
    "price": 809,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Babyhug",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.2,
    "reviews": 34,
    "inStock": true,
    "description": "A great Tops & Shirts from Babyhug specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 139,
    "name": "Babyhug Kids Tops & Shirts Collection V5",
    "price": 1223,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Babyhug",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.4,
    "reviews": 101,
    "inStock": true,
    "description": "A great Tops & Shirts from Babyhug specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 140,
    "name": "Allen Solly Junior Kids Tops & Shirts Collection V1",
    "price": 1054,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Allen Solly Junior",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.1,
    "reviews": 67,
    "inStock": true,
    "description": "A great Tops & Shirts from Allen Solly Junior specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 141,
    "name": "Allen Solly Junior Kids Tops & Shirts Collection V2",
    "price": 817,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Allen Solly Junior",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.1,
    "reviews": 44,
    "inStock": true,
    "description": "A great Tops & Shirts from Allen Solly Junior specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 142,
    "name": "Allen Solly Junior Kids Tops & Shirts Collection V3",
    "price": 724,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Allen Solly Junior",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.2,
    "reviews": 85,
    "inStock": true,
    "description": "A great Tops & Shirts from Allen Solly Junior specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 143,
    "name": "Allen Solly Junior Kids Tops & Shirts Collection V4",
    "price": 911,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Allen Solly Junior",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.6,
    "reviews": 16,
    "inStock": true,
    "description": "A great Tops & Shirts from Allen Solly Junior specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 144,
    "name": "Allen Solly Junior Kids Tops & Shirts Collection V5",
    "price": 874,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Allen Solly Junior",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.8,
    "reviews": 29,
    "inStock": true,
    "description": "A great Tops & Shirts from Allen Solly Junior specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 145,
    "name": "Kookie Kids Kids Tops & Shirts Collection V1",
    "price": 1378,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Kookie Kids",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.4,
    "reviews": 10,
    "inStock": true,
    "description": "A great Tops & Shirts from Kookie Kids specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 146,
    "name": "Kookie Kids Kids Tops & Shirts Collection V2",
    "price": 1167,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Kookie Kids",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.2,
    "reviews": 27,
    "inStock": true,
    "description": "A great Tops & Shirts from Kookie Kids specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 147,
    "name": "Kookie Kids Kids Tops & Shirts Collection V3",
    "price": 976,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Kookie Kids",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.2,
    "reviews": 67,
    "inStock": true,
    "description": "A great Tops & Shirts from Kookie Kids specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 148,
    "name": "Kookie Kids Kids Tops & Shirts Collection V4",
    "price": 909,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Kookie Kids",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.6,
    "reviews": 100,
    "inStock": true,
    "description": "A great Tops & Shirts from Kookie Kids specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 149,
    "name": "Kookie Kids Kids Tops & Shirts Collection V5",
    "price": 1270,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "Kookie Kids",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.4,
    "reviews": 33,
    "inStock": true,
    "description": "A great Tops & Shirts from Kookie Kids specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 150,
    "name": "H&M Kids Tops & Shirts Collection V1",
    "price": 1227,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "H&M",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.3,
    "reviews": 59,
    "inStock": true,
    "description": "A great Tops & Shirts from H&M specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 151,
    "name": "H&M Kids Tops & Shirts Collection V2",
    "price": 557,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "H&M",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.9,
    "reviews": 34,
    "inStock": true,
    "description": "A great Tops & Shirts from H&M specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 152,
    "name": "H&M Kids Tops & Shirts Collection V3",
    "price": 814,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "H&M",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.7,
    "reviews": 17,
    "inStock": true,
    "description": "A great Tops & Shirts from H&M specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 153,
    "name": "H&M Kids Tops & Shirts Collection V4",
    "price": 1018,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "H&M",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.2,
    "reviews": 84,
    "inStock": true,
    "description": "A great Tops & Shirts from H&M specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  },
  {
    "id": 154,
    "name": "H&M Kids Tops & Shirts Collection V5",
    "price": 507,
    "category": "Kids",
    "subcategory": "Tops & Shirts",
    "brand": "H&M",
    "image": "/images/kids_frozen_top.png",
    "rating": 4.3,
    "reviews": 98,
    "inStock": true,
    "description": "A great Tops & Shirts from H&M specifically designed for Kids. High quality and durable.",
    "color": "Multicolor",
    "size": [
      "S",
      "M",
      "L"
    ]
  }
];

export const categories = [
  { id: 'women', name: 'Women', icon: '👗', subcategories: ['Dress', 'Tops', 'Saree'] },
  { id: 'men', name: 'Men', icon: '👔', subcategories: ['Tshirts', 'Jeans'] },
  { id: 'kids', name: 'Kids', icon: '🧒', subcategories: ['Dress', 'Tops & Shirts'] },
].map(cat => ({ ...cat, count: products.filter(p => p.category === cat.name).length }));

export const brands = [
  { name: 'Polo' }, { name: 'H&M' }, { name: 'Madame' }, { name: 'Mast & Harbour' },
  { name: 'Babyhug' }, { name: 'Allen Solly Junior' }, { name: 'Kookie Kids' }, { name: 'Biba' }
].map(b => ({ ...b, count: products.filter(p => p.brand === b.name).length }));
